<!--
/**
 * APCWO customisation for OrangeHRM — Email Templates module.
 *
 * Licensed under the GNU General Public License v2.0 or later, the same terms
 * as OrangeHRM itself. See the LICENSE file at the project root.
 */
-->

<template>
  <div class="apcwo-html-preview">
    <div class="apcwo-html-preview__bar">
      <oxd-text tag="p" class="apcwo-html-preview__subject">
        <strong>Subject:</strong> {{ preview.subject || '—' }}
      </oxd-text>
      <oxd-text v-if="error" tag="p" class="apcwo-html-preview__error">
        {{ error }}
      </oxd-text>
    </div>
    <iframe
      class="apcwo-html-preview__frame"
      sandbox="allow-same-origin"
      :srcdoc="preview.body"
      title="Email preview"
    ></iframe>
  </div>
</template>

<script>
import {APIService} from '@ohrm/core/util/services/api.service';

export default {
  name: 'HtmlPreview',
  props: {
    subject: {
      type: String,
      default: '',
    },
    bodyHtml: {
      type: String,
      default: '',
    },
    eventType: {
      type: String,
      default: null,
    },
    sampleEmpNumber: {
      type: Number,
      default: null,
    },
  },
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/apcwo/email-templates/preview',
    );
    http.setIgnorePath('/api/v2/apcwo/email-templates/preview');
    return {http};
  },
  data() {
    return {
      preview: {subject: '', body: ''},
      error: null,
      timer: null,
    };
  },
  watch: {
    subject: 'schedule',
    bodyHtml: 'schedule',
    eventType: 'schedule',
    sampleEmpNumber: 'schedule',
  },
  mounted() {
    this.refresh();
  },
  beforeUnmount() {
    if (this.timer) clearTimeout(this.timer);
  },
  methods: {
    schedule() {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(this.refresh, 400);
    },
    refresh() {
      this.http
        .create({
          subject: this.subject || '',
          bodyHtml: this.bodyHtml || '',
          eventType: this.eventType || undefined,
          sampleEmpNumber: this.sampleEmpNumber || undefined,
        })
        .then((response) => {
          this.error = null;
          this.preview = response.data.data;
        })
        .catch((e) => {
          const message = e?.response?.data?.error?.message;
          this.error = message || 'Preview could not be rendered.';
        });
    },
  },
};
</script>

<style scoped>
.apcwo-html-preview {
  border: 1px solid #d9dbdd;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}
.apcwo-html-preview__bar {
  padding: 8px 12px;
  border-bottom: 1px solid #eceef0;
  background: #f7f8f9;
}
.apcwo-html-preview__subject {
  font-size: 13px;
}
.apcwo-html-preview__error {
  margin-top: 4px;
  font-size: 12px;
  color: #e03c3c;
}
.apcwo-html-preview__frame {
  display: block;
  width: 100%;
  height: 360px;
  border: 0;
  background: #fff;
}
</style>
